import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=6d533e3a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=6d533e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d533e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d533e3a')) {
      api.createRecord('6d533e3a', component.options)
    } else {
      api.reload('6d533e3a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=6d533e3a&scoped=true&", function () {
      api.rerender('6d533e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kvPBXCEXBZjc/JS/comp/DocBox.vue"
export default component.exports